import isObject from '#shared/util/isObject.js';
import appError from '#shared/util/appError.js';
import appDebug from '#shared/util/appDebug.js';
import readArguments from '#shared/util/readArguments.js';

const events = {};
const removeListener = (listeners, listener) => {
	listeners.forEach((item, index) => {
		if (item === listener) {
			listeners.splice(index, 1);
		}
	});
};

/**
 * window.app polyfill
 */
if (!isObject(window.app)) {
	window.app = {};
}

/**
 * window.app.avEvents polyfill
 */
if (!isObject(window.app.avEvents)) {
	window.app.avEvents = {};
}

/**
 * window.app.avEvents.emitEvent implementation
 * @param {string} event
 * @param {string} [response]
 */
window.app.avEvents.emitEvent = (event, response) => {
	const listeners = events[event];
	if (typeof listeners !== 'undefined') {
		listeners.forEach((listener) => {
			const customEvent = new CustomEvent(event);
			listener(customEvent, response);
		});
	}
};

/**
 * window.app.avastEvents.emitEvent polyfill
 */
if (isObject(window.app.avastEvents)) {
	window.app.avastEvents.emitEvent = window.app.avEvents.emitEvent;
}

/**
 * Standalone client polyfill
 */
window.addEventListener('message', (event) => {
	if (/^(?:.+\.)?(?:avast|avg)\.com$/.test(event.origin) && isObject(event.data) && typeof event.data.action === 'string' && event.data.action) {
		window.app.avEvents.emitEvent(event.data.action, event.data.data);
	}
}, false);

export default {

	/**
	 * Add event listener
	 * @param {string} event
	 * @param {Function} listener
	 */
	addEventListener(event, listener) {
		if (typeof event === 'string' && typeof listener === 'function') {
			const listeners = events[event] = events[event] || [];
			if (listeners.length) {
				removeListener(listeners, listener);
			}
			listeners.push(listener);
		} else {
			throw appError('Invalid method arguments to avEvents.addEventListener', {
				code: 'APP_FRONTEND_UTIL',
				origin: 'avEvents.addEventListener',
				detail: readArguments(arguments) // @todo update detail structure
			});
		}
	},

	/**
	 * Remove event listener
	 * @param {string} event
	 * @param {Function} listener
	 */
	removeEventListener(event, listener) {
		if (typeof event === 'string' && typeof listener === 'function') {
			const listeners = events[event] || [];
			if (listeners.length) {
				removeListener(listeners, listener);
			}
			if (!listeners.length) {
				delete events[event];
			}
		} else {
			throw appError('Invalid method arguments to avEvents.removeEventListener', {
				code: 'APP_FRONTEND_UTIL',
				origin: 'avEvents.removeEventListener',
				detail: readArguments(arguments) // @todo update detail structure
			});
		}
	},

	/**
	 * Dispatch event
	 * @param {object} event
	 * @param {*} [response]
	 * @returns {boolean}
	 */
	dispatchEvent(event, response) {
		if (isObject(event)) {
			appDebug(`avEvent ${event.type}`, {
				code: 'APP_FRONTEND_UTIL',
				origin: 'avEvents.dispatchEvent',
				detail: {
					event,
					response
				}
			});
			window.app.avEvents.emitEvent(event.type, response);
			return true;
		} else {
			throw appError('Invalid method arguments to avEvents.dispatchEvent', {
				code: 'APP_FRONTEND_UTIL',
				origin: 'avEvents.dispatchEvent',
				detail: readArguments(arguments) // @todo update detail structure
			});
		}
	}

};
